import script from "./FloatingChatWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingChatWindow.vue?vue&type=script&setup=true&lang=js"

import "./FloatingChatWindow.vue?vue&type=style&index=0&id=34c3f341&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c3f341"]])

export default __exports__